import { Model, HasOne, BelongsTo, Attr } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';
import type LegalEntity from '../../LegalEntity';

@Model()
class AuditsExportsRemindersExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-reminders_exports';

  // Attributes
  @Attr() legalEntityId!: string;

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
  @BelongsTo() legalEntity?: LegalEntity;
}

export default AuditsExportsRemindersExport;
